var map = {
	"./brazil/photo/lk_photo_templo_gangaramaya.jpg": 539,
	"./brazil/puzzle/lk_puzzle_templo_gangaramaya.jpg": 540,
	"./china/photo/lk_photo_templo_gangaramaya.jpg": 541,
	"./china/puzzle/lk_puzzle_templo_gangaramaya.jpg": 542,
	"./cutscene-inicial/matilde-train.png": 380,
	"./greece/chapters/gc-chapter-1.png": 381,
	"./greece/chapters/gc-chapter-2.png": 382,
	"./greece/chapters/gc-chapter-3.png": 383,
	"./greece/gc-akrotiri.png": 384,
	"./greece/gc-athena-temple.png": 385,
	"./greece/gc-athens-arrival.png": 386,
	"./greece/gc-barco.png": 387,
	"./greece/gc-beach-bad.png": 388,
	"./greece/gc-beach-good.png": 389,
	"./greece/gc-beach-so-so.png": 390,
	"./greece/gc-breakfast-bad.png": 391,
	"./greece/gc-breakfast-good.png": 392,
	"./greece/gc-bus-happy.png": 393,
	"./greece/gc-bus-mad.png": 394,
	"./greece/gc-bus-stop.png": 395,
	"./greece/gc-dionisio.png": 396,
	"./greece/gc-hotel-lobby.png": 397,
	"./greece/gc-hotel-room.png": 398,
	"./greece/gc-hotel-room2.png": 399,
	"./greece/gc-hotel.png": 400,
	"./greece/gc-journey.png": 401,
	"./greece/gc-kolonaki.png": 402,
	"./greece/gc-lisbon-sight.png": 403,
	"./greece/gc-plaka-bad.png": 404,
	"./greece/gc-plaka-good.png": 405,
	"./greece/gc-recepcionist.png": 406,
	"./greece/gc-restaurant.png": 407,
	"./greece/gc-street-bad.png": 408,
	"./greece/gc-street-good.png": 409,
	"./greece/gc-taxi-bags.png": 410,
	"./greece/gc-taxi-ride.png": 411,
	"./greece/gc-taxi.png": 412,
	"./greece/photo/gc-athens-beach.png": 413,
	"./greece/photo/gc-partenon-end.png": 414,
	"./greece/photo/gc-partenon.png": 415,
	"./greece/photo/gc-souvlaki.png": 416,
	"./greece/photo/gc-sunset-oia.png": 417,
	"./greece/puzzle/gc-puzzle-acropole.png": 418,
	"./greece/puzzle/gc-puzzle-boat-view.jpg": 543,
	"./mountain-view.jpg": 544,
	"./puzzle.png": 419,
	"./quizz.png": 420,
	"./sri-lanka/mountain-view.png": 421,
	"./sri-lanka/photo/lk-cargills-store.png": 422,
	"./sri-lanka/photo/lk-old-dutch-hospital.png": 423,
	"./sri-lanka/photo/lk-old-galle-buck.png": 424,
	"./sri-lanka/photo/lk-templo-gangaramaya.jpg": 545,
	"./sri-lanka/puzzle/lk-puzzle-cargills-main_store.png": 425,
	"./sri-lanka/puzzle/lk-puzzle-templo-gangaramaya.jpg": 546,
	"./wordsearch.png": 426
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 259;